export default "__VITE_ASSET__Dzwsewe4__"